import Form from '~/components/unform/Form'

import { useRechargeForm } from '../../hooks/useRechargeForm'
import AddressSection from './elements/AddressSection'
import AmountSection from './elements/AmountSection'
import { BillingInformationFieldset } from './elements/BillingInformationFieldset'
import Footer from './elements/Footer'
import MethodSection from './elements/MethodSection'

import * as S from './styles'

const FormRecharge = () => {
  const {
    initialData,
    formRef,
    addressStepIsRequired,
    handleChangeForm,
    handleSubmit
  } = useRechargeForm()

  return (
    <S.Container>
      <Form
        ref={formRef}
        initialData={initialData}
        onSubmit={handleSubmit}
        onChange={handleChangeForm}
      >
        <AmountSection />

        <MethodSection />

        <BillingInformationFieldset />

        {addressStepIsRequired && <AddressSection />}

        <Footer />
      </Form>
    </S.Container>
  )
}

export default FormRecharge
